import { Optional } from 'chaika-frontend-types/frontend-cms';

import { getPhoneCodeParams } from '@components/Input/PhoneInput/utils/phoneParams';
import { removeNotNumbers } from '@utils/removeNotNumbers';

export function formatPhoneNumber(phoneNumber: string = ''): Optional<string> {
    const digits = removeNotNumbers(phoneNumber);
    const { phoneMask } = getPhoneCodeParams(digits);

    if (!phoneMask || countMaskDigitSlots(phoneMask) !== digits.length) {
        return undefined;
    }

    return fillMask(phoneMask, digits).replace('(', ' (').replace(')', ') ');
}

function countMaskDigitSlots(mask: string): number {
    return mask.replace(/[^\d#]/g, '').length;
}

function fillMask(mask: string, digits: string): string {
    let digitIndex = 0;

    return mask.replace(/[\d#]/g, () => digits[digitIndex++]);
}
